import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.funding_requirements.action_applicant_call_title',
        defaultMessage: 'Give us a quick call'
    },
    caption: {
        id: '_.funding_requirements.action_applicant_call_caption',
        defaultMessage: 'We need to talk to you over the phone.'
    },
    action: {
        id: '_.funding_requirements.call_action',
        defaultMessage: 'Call Now'
    },
    pending: {
        id: '_.funding_requirements.call_action_pending',
        defaultMessage: 'Pending'
    },
    modalTitle: {
        id: '_.funding_requirements.action_applicant_call_modal_title',
        defaultMessage: 'Give us a quick call'
    },
    availabilityMessageLineOne: {
        id: '_.funding_requirements.action_applicant_call_modal.availability_message_line_one',
        defaultMessage: 'Monday to Friday (excluding bank holidays)'
    },
    timesForMessageLineOne: {
        id: '_.funding_requirements.action_applicant_call_modal.times_for_message_line_one',
        defaultMessage: '9am - 6pm'
    },
    displayPhoneNumber: {
        id: '_.funding_requirements.action_applicant_call_modal.displayPhoneNumber',
        defaultMessage: '020 3778 0105'
    },
    callPhoneNumber: {
        id: '_.funding_requirements.action_applicant_call_modal.callPhoneNumber',
        defaultMessage: '+44-020-3778-0105'
    },
    callSubText: {
        id: '_.funding_requirements.action_applicant_call_modal.call_sub_text',
        defaultMessage:
            "You're nearly there. Based on your application so far, you'll need to call your account manager to finish the last step."
    }
});
